import React, { useState } from "react";
import { Box, Typography, Button, Container, Modal,   } from "@mui/material";
import { useLocationContext } from "../../Hooks/CustomHooks";
import { useLocation, useNavigate } from "react-router-dom";
import { loginRequest } from "../../authConfig";
import { useMsal } from "@azure/msal-react";
import { CustomTextField,CustomDropDown, CustomDateTimePicker } from "../Inputs/CustomInputs";
import { updateLookup } from "../../serviceCalls";
import {
  fileTypes,
  triggerTypes
} from "./selectOptions";
import dayjs from 'dayjs';
import {ProgressBar} from "../CustomProgressBar/ProgressBar";
import {successStyle, CheckmarkImg, ErrorDiv} from './updateLookUpStyles';

const UpdateLookup = () => {
  const currentLocation = useLocationContext();
  const location = useLocation();
  const { accounts, instance } = useMsal();
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = useState(false);
  const navigate=useNavigate();
  const [displayLoading, setDisplayLoading] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [correlationId, setCorrelationId] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  
  const [lookupData, setLookupData] = useState(
    location.state ? location.state.lookupData : {}
  );

  const pageNo=location.state?location.state.pageNo:1
  const limit =location.state?location.state.limit:5

  const [originName, setOriginName] = useState(lookupData.originName);
  const [containerName, setContainerName] = useState(
    lookupData.containerName
  );

  const [sourceFolderPath, setSourceFolderPath] = useState(lookupData.sourceFolderPath);
  const [destinationFolderPath, setDestinationFolderPath] = useState(
    lookupData.destinationFolderPath
  );
  const [fileName, setFileName] = useState(
    lookupData.fileName
  );
  const [fileType, setFileType] = useState(
    lookupData.fileType
  );

  const [triggerName, setTriggerName] = useState(lookupData.triggerName);
  const [triggerType, setTriggerType] = useState(lookupData.triggerType);

 

  const handleUpdate = async (event) => {
    try {
    setDisplayLoading(true);
    event.preventDefault();
    const updateLookUpData = {
        originName: originName,
        containerName: containerName,
        sourceFolderPath: sourceFolderPath,
        fileName: fileName,
        destinationFolderPath: destinationFolderPath,
        fileType: fileType,
        StartDateTime: lookupData.StartDateTime,
    };
    

    const tokenResponse = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    const accessToken = await tokenResponse.accessToken;
    const response = await updateLookup(updateLookUpData, accessToken);
    const apiResponse=response?.data

    if (apiResponse.StatusCode === 200) {
      setDisplayLoading(false);
      await setUpdateSuccess(true);
      await setTimeout(()=>{
        navigate('/getalllookupdata',{state:{pageNo:pageNo,limit:limit}})
      }
     ,2000)
    } else {
        setDisplayLoading(false);
        setCorrelationId(response?.headers["x-correlation-id"]);
        setAlertMsg(apiResponse.Message);
        setAlertSeverity("error");
    }
  } catch (error) {
    setDisplayLoading(false);
    setAlertMsg(error.message);
    setCorrelationId(error.response.headers["x-correlation-id"]);
    setAlertSeverity("error");
  }
  };

  const handleCloseButtonClick = () => {
    navigate('/getalllookupdata',{state:{pageNo:pageNo,limit:limit}})
  }

  return (
    <>
      {displayLoading ? (<ProgressBar />) : <>
        <Box sx={{ display: "flex", marginLeft: 3, marginBottom: 5 }}>
          <Typography fontSize={48} color="primary">
            Edit - Lookup
            <img
              style={{
                margin: "4px 0px 0px 22px",
              }}
              height={45}
              width={50}
              src={require("../../images/PipelineIcon.png")}
              alt="images"></img>
          </Typography>
        </Box>

        <Container
          sx={{
            paddingY: 22,
            boxShadow: 2,
            padding: 2,
            height: 550,
            width: 1215,
          }}
        >
          <Box>
              {alertMsg && (
                <ErrorDiv severity={alertSeverity}>
                  <span>
                    Error Occured:  {alertMsg}. Correlation Id : {correlationId}
                  </span>
                </ErrorDiv>
              )}
            </Box>
          <Typography sx={{ margin: -2 }} fontSize={24}>
            Pipeline ID : {lookupData.PipelineMappingId}
          </Typography>

          <CustomTextField
            id="OriginName"
            placeholder={"Origin Name"}
            fieldName={"Origin Name"}
            value={originName}
            disabled={true}
            isRequired={true}
            toolTipTitle={
              "Valid Name for the pipeline based on its usage.Pipeline Name should be Unique and should not contain white spaces or special characters."
            }
          />
          <CustomTextField
            id="ContainerName"
            placeholder={"Container Name"}
            fieldName={"Container Name"}
            value={containerName}
            onChange={(e) => setContainerName(e.target.value)}
            disabled={false}
            isRequired={true}
            toolTipTitle={
              "Valid Container Name for the pipeline based on its usage.Pipeline Name should be Unique and should not contain white spaces or special characters."
            }
          />
          <CustomTextField
            id="SourceFolderPath"
            placeholder={"Source Folder Path"}
            fieldName={"Source Folder Path"}
            value={sourceFolderPath}
            onChange={(e) => setSourceFolderPath(e.target.value)}
            disabled={false}
            isRequired={true}
            toolTipTitle={
              "Valid Container Name for the pipeline based on its usage.Pipeline Name should be Unique and should not contain white spaces or special characters."
            }
          />
          <CustomTextField
            id="DestinationFolderPath"
            placeholder={"Destination Folder Path"}
            fieldName={"Destination Folder Path"}
            value={destinationFolderPath}
            onChange={(e) => setDestinationFolderPath(e.target.value)}
            disabled={false}
            isRequired={true}
            toolTipTitle={
              "Valid Container Name for the pipeline based on its usage.Pipeline Name should be Unique and should not contain white spaces or special characters."
            }
          />
          <CustomTextField
            id="FileName"
            placeholder={"File Name"}
            fieldName={"File Name"}
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
            disabled={false}
            isRequired={true}
            toolTipTitle={
              "Valid Container Name for the pipeline based on its usage.Pipeline Name should be Unique and should not contain white spaces or special characters."
            }
          />
          <CustomDropDown
            id={"FileType"}
            fieldName={"File Type"}
            value={fileType}
            isRequired={true}
            onChange={(e) => setFileType(e.target.value)}
            menuItems={fileTypes}
          />
          <CustomTextField
            id="TriggerName"
            placeholder={"Trigger Name"}
            fieldName={"Trigger Name"}
            value={triggerName}
            disabled={true}
            onChange={(e) => setTriggerName(e.target.value)}
            isRequired={true}
            toolTipTitle={
              "Valid Trigger Name for the Trigger based on its usage. Trigger Name should be Unique and should not contain white spaces or special characters."
            }
          />
          <CustomDropDown
            id={"TriggerType"}
            fieldName={"Trigger Type"}
            disabled={true}
            value={triggerType}
            isRequired={true}
            onChange={(e) => setFileType(e.target.value)}
            menuItems={triggerTypes}
          />
          <CustomDateTimePicker
            id="TriggerStartDateTime"
            placeholder={"Trigger Start Datetime (UTC)"}
            fieldName={"Trigger Start Datetime (UTC)"}
            value={dayjs(lookupData.StartDateTime)}
            disabled={true}
            isRequired={true}
            toolTipTitle={
              "Valid Container Name for the pipeline based on its usage.Pipeline Name should be Unique and should not contain white spaces or special characters."
            }
          />
        </Container>
        <Container
          sx={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}
        >
          <Button variant="contained"
            color="primary"
            size="large"
            onClick={() => handleCloseButtonClick()}
          >Close</Button>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={handleUpdate}
          >
            Update
          </Button>
        </Container>
        <div>
          <Modal
            open={updateSuccess}
            onClose={() => setUpdateSuccess(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={successStyle}>
              <Box sx={{ display: "flex-inline" }}>
                <Typography align="center" mb={2} mt={4} fontSize={24}>
                  Pipeline Updated
                </Typography>
                <center>
                  <CheckmarkImg
                    onClick={handleClose}
                    src={require("../../images/Checkmark.png")}
                  />
                </center>
              </Box>
            </Box>
          </Modal>
        </div>
      </>
      }
    </>
  );
};

export default UpdateLookup;
